import {createApp, isRef, nextTick} from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import {createPinia} from 'pinia'

import router from "@/router";
import JsonViewer from 'vue-json-viewer'

const app = createApp(App);
app.use(Antd);
app.use(createPinia())
app.use(router);
app.use(JsonViewer)

// 切换TAB,重新获取数据
app.config.globalProperties.changeTab = (tabs, currentTabKey) => {
    tabs.forEach((tab) => {
        if (tab.key === currentTabKey && isRef(tab.ref)) {
            if (tab.ref.value !== undefined) {
                nextTick(() => {
                    if (tab.ref.value.hasOwnProperty('getData')) {
                        tab.ref.value.getData()
                    }
                }).then(() => {
                })
            }
        }
    })
}

app.mount('#app');